import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import HeaderSection from './HeaderSection.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AcreditacionFinalizada',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderSection),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-gray-100 py-36 flex flex-col items-center justify-center min-h-screen" }, [
      _createElementVNode("h2", { class: "text-5xl" }, "Entradas agotadas"),
      _createElementVNode("h2", { class: "text-5xl" }, "La inscripción se encuentra cerrada."),
      _createElementVNode("h2", { class: "text-5xl" }, "¡Los esperamos en 2026! ")
    ], -1))
  ], 64))
}
}

})